import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotificationState {
  // Per-user ISO timestamp of when the requests list was last viewed.
  requestsLastSeen: Record<string, string>;
  markRequestsSeen: (userId: string) => void;
}

export const useNotificationStore = create<NotificationState>()(
  persist(
    (set) => ({
      requestsLastSeen: {},
      markRequestsSeen: (userId) =>
        set((state) => ({
          requestsLastSeen: { ...state.requestsLastSeen, [userId]: new Date().toISOString() },
        })),
    }),
    { name: 'notification-storage' }
  )
);
